import { createFileRoute } from "@tanstack/react-router";
import { CustomerDetailPage } from "@charphq/ui/components/layout/pages/CustomerDetailPage";

export const Route = createFileRoute("/customers_/$customerId")({
  component: CustomerDetailComponent,
});

function CustomerDetailComponent() {
  const { customerId } = Route.useParams();
  return <CustomerDetailPage customerId={customerId} />;
}
